const coreSize = 1;

export const size = (multiplier: number): string => `${multiplier * coreSize}rem`;
